// 开发时在这里切换后端：online 连接线上，local 连接本机。修改后重启开发服务。
export const DEVELOPMENT_API_TARGET: 'online' | 'local' = 'online';
export const API_SERVERS = {
  online: 'https://api.billiard.hetuntech.cn',
  local: 'http://localhost:8080',
};
export const DEVELOPMENT_API_ORIGIN = API_SERVERS[DEVELOPMENT_API_TARGET];
